module.exports = __webpack_public_path__ + "img/big.1c46d8f9.jpg";